module.exports = __webpack_public_path__ + "img/selected3-min.123d1c64.png";